export default __webpack_public_path__ + "static/media/icon-uae-flag.7741a4d5.svg";